import React from 'react';
import Link from 'next/link';

import {
  ALDAR_BRAND,
  ART,
  BUSINESS_DEVELOPMENT,
  BUSINESS_INVESTMENT,
  CAREERS,
  CORPORATE_GOVERNANCE,
  EDUCATION,
  EXPLORE_ABU_DHABI,
  EXPLORE_ALDAR,
  E_SERVICES,
  HOSPITALITY,
  INNOVATION,
  INVESTORS_RELATIONS,
  LIVE_ALDAR,
  LeftBlock,
  MEDIA,
  PROJECTS,
  SUSTAINABILITY,
} from './TopSection.constants';
import SVGIcons from '@components/SVGIcon';

import cn from './TopSection.module.scss';
import {trackMouseClicks} from '@utils/googleAnalytics/googleAnalyticsEvents';
import MuiContainer from '@new-components/atoms/MuiContainer';

export function TopSection() {
  return (
    <div className={cn.footer}>
      <MuiContainer sx={{padding: '0px !important'}} className={cn.wrapper}>
        <div className={cn.leftPane}>
          <div className={cn.leftPane__list}>
            {LeftBlock.map((item) => (
              <Link
                href={item.link}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: item.link,
                    },
                    {name: item.label}
                  )
                }
                key={item.label}
                className={cn.label}
                prefetch={false}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <div className={cn.rightPane}>
          <div className={cn.firstSection}>
            <div className={cn.blockOne}>
              <Link
                href={EXPLORE_ABU_DHABI.link}
                className={cn.heading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: EXPLORE_ABU_DHABI.link,
                    },
                    {name: EXPLORE_ABU_DHABI.mainHeading}
                  )
                }
                prefetch={false}>
                {EXPLORE_ABU_DHABI.mainHeading}
              </Link>
              <div className={cn.list}>
                {EXPLORE_ABU_DHABI.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockTwo}>
              <span className={cn.heading}>{MEDIA.mainHeading}</span>
              <div className={cn.list}>
                {MEDIA.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockThree}>
              <Link
                href={INVESTORS_RELATIONS.link}
                className={cn.heading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: INVESTORS_RELATIONS.link,
                    },
                    {name: INVESTORS_RELATIONS.mainHeading}
                  )
                }
                prefetch={false}>
                {INVESTORS_RELATIONS.mainHeading}
              </Link>
              <div className={cn.list}>
                {INVESTORS_RELATIONS.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockFour}>
              <span className={cn.heading}>{CAREERS.mainHeading}</span>
              <div className={cn.list}>
                {CAREERS.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    target={item.icon ? '_blank' : ''}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    <span>{item.label}</span>
                    <span>
                      {item.icon && <SVGIcons type={'redirect-svg'} />}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className={cn.secondSection}>
            <div className={cn.blockOne}>
              <Link
                href={EXPLORE_ALDAR.link}
                className={cn.heading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: EXPLORE_ALDAR.link,
                    },
                    {name: EXPLORE_ALDAR.mainHeading}
                  )
                }
                prefetch={false}>
                {EXPLORE_ALDAR.mainHeading}
              </Link>
              <span className={cn.noninteractableSubHeading}>
                {EXPLORE_ALDAR.subHeading}
              </span>
              <div className={cn.list}>
                {EXPLORE_ALDAR.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockTwo}>
              <span className={cn.heading}>{E_SERVICES.mainHeading}</span>
              <div className={cn.list}>
                {E_SERVICES.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    target={item.icon ? '_blank' : ''}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    <span>{item.label}</span>
                    <span>
                      {item.icon && <SVGIcons type={'redirect-svg'} />}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className={cn.thirdSection}>
            <div className={cn.blockOne}>
              <span className={cn.noninteractableSubHeading}>
                {BUSINESS_DEVELOPMENT.mainHeading}
              </span>
              <div className={cn.list}>
                {BUSINESS_DEVELOPMENT.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockTwo}>
              <span className={cn.noninteractableSubHeading}>
                {BUSINESS_INVESTMENT.mainHeading}
              </span>
              <div className={cn.list}>
                {BUSINESS_INVESTMENT.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockThree}>
              <Link
                href={EDUCATION.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: EDUCATION.link,
                    },
                    {name: EDUCATION.mainHeading}
                  )
                }
                prefetch={false}>
                {EDUCATION.mainHeading}
              </Link>
            </div>
            <div className={cn.blockFour}>
              <Link
                href={HOSPITALITY.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: HOSPITALITY.link,
                    },
                    {name: HOSPITALITY.mainHeading}
                  )
                }
                prefetch={false}>
                {HOSPITALITY.mainHeading}
              </Link>
            </div>
            <div className={cn.blockFive}>
              <Link
                href={PROJECTS.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: PROJECTS.link,
                    },
                    {name: PROJECTS.mainHeading}
                  )
                }
                prefetch={false}>
                {PROJECTS.mainHeading}
              </Link>
            </div>
            <div className={cn.blockSix}>
              <Link
                href={CORPORATE_GOVERNANCE.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: CORPORATE_GOVERNANCE.link,
                    },
                    {name: CORPORATE_GOVERNANCE.mainHeading}
                  )
                }
                prefetch={false}>
                {CORPORATE_GOVERNANCE.mainHeading}
              </Link>
            </div>
            <div className={cn.blockSeven}>
              <Link
                href={SUSTAINABILITY.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: SUSTAINABILITY.link,
                    },
                    {name: SUSTAINABILITY.mainHeading}
                  )
                }
                prefetch={false}>
                {SUSTAINABILITY.mainHeading}
              </Link>
              <div className={cn.list}>
                {SUSTAINABILITY.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className={cn.fourthSection}>
            <div className={cn.blockOne}>
              <Link
                href={ALDAR_BRAND.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: ALDAR_BRAND.link,
                    },
                    {name: ALDAR_BRAND.mainHeading}
                  )
                }
                prefetch={false}>
                {ALDAR_BRAND.mainHeading}
              </Link>
            </div>
            <div className={cn.blockTwo}>
              <Link
                href={LIVE_ALDAR.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: LIVE_ALDAR.link,
                    },
                    {name: LIVE_ALDAR.mainHeading}
                  )
                }
                prefetch={false}>
                {LIVE_ALDAR.mainHeading}
              </Link>
              <div className={cn.list}>
                {LIVE_ALDAR.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    target={item.icon ? '_blank' : ''}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    <span>{item.label}</span>
                    <span>
                      {item.icon && <SVGIcons type={'redirect-svg'} />}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
            <div className={cn.blockThree}>
              <Link
                href={ART.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: ART.link,
                    },
                    {name: ART.mainHeading}
                  )
                }
                prefetch={false}>
                {ART.mainHeading}
              </Link>
            </div>
            <div className={cn.blockFour}>
              <Link
                href={INNOVATION.link}
                className={cn.subHeading}
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: INNOVATION.link,
                    },
                    {name: INNOVATION.mainHeading}
                  )
                }
                prefetch={false}>
                {INNOVATION.mainHeading}
              </Link>
              <div className={cn.list}>
                {INNOVATION.subLinks.map((item) => (
                  <Link
                    href={item.link}
                    className={cn.list__item}
                    key={item.link}
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: item.link,
                        },
                        {name: item.label}
                      )
                    }
                    prefetch={false}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </MuiContainer>
    </div>
  );
}
